module.exports = __webpack_public_path__ + "static/media/logo-color.0c69ce58.svg";